// Use CommonJS-style requires so that execution order is preserved in the
// bundled IIFE.

// 1) Require jQuery and expose it globally so that any libraries that expect a
//    global `jQuery` (like jquery-ui) can find it.
const jquery = require("jquery");
window.$ = window.jQuery = jquery;

// 2) Now that global jQuery exists, safely require jQuery UI pieces needed for
//    autocomplete. Load core, widget factory, position helper, menu, then the
//    autocomplete widget itself. This requires the `jquery-ui` npm package.
require("jquery-ui/dist/jquery-ui");
require("jquery-ui/ui/widget");
require("jquery-ui/ui/position");
require("jquery-ui/ui/widgets/menu");
require("jquery-ui/ui/widgets/autocomplete");

// 3) Load Foundation JS so that $(...).foundation() is available for legacy
//    code and inline scripts. Requires `foundation-sites` npm package.
require("foundation-sites");

// FlexSlider jQuery plugin for legacy survey_slider.js
// Requires the `flexslider` npm package.
require("flexslider");

// wordcloud2.js — vendor library used by results_text_responses.js.
// Previously loaded via a Sprockets `//= require wordcloud2` directive
// (ignored by esbuild), so it must be required explicitly here.
window.WordCloud = require("../../../vendor/assets/javascripts/wordcloud2");

// GeoJSON.js — vendor library used by maps.js for MultiPolygon rendering.
// Previously loaded via a Sprockets `//= require GeoJSON` directive (ignored
// by esbuild), so it must be required explicitly here.
window.GeoJSON = require("../../../vendor/assets/javascripts/GeoJSON");

// 4) Provide a minimal ClientSideValidations global for legacy code that
//    expects ClientSideValidations.formBuilders and callbacks to exist.
require("./client_side_validations_shim");

// 5) Finally, start Rails UJS now that jQuery (and plugins) are in place.
const Rails = require("@rails/ujs");
window.Rails = Rails;      // expose for console / legacy code
Rails.start();

require("@hotwired/turbo");
Turbo.session.drive = false
// Turbo sets history.scrollRestoration = "manual" on import, which prevents
// the browser from scrolling to hash anchors (e.g. #how-it-works) on page load.
// Restore native behavior since drive is disabled.
if (window.history && window.history.scrollRestoration) {
  window.history.scrollRestoration = "auto";
}
// require("@hotwired/stimulus"); // optional later
require("./legacy");
require("./legacy_init");


function isSameOrigin(url) {
  const loc = window.location;
  const a = document.createElement('a');
  a.href = url;

  // For relative URLs, the browser resolves to current origin automatically
  return a.protocol === loc.protocol && a.host === loc.host;
}

function currentCsrfToken() {
  const el = document.querySelector('meta[name="csrf-token"]');
  return el && el.getAttribute('content');
}
